import { useTranslation } from '@wix/yoshi-flow-editor';
import React from 'react';
import type { SubscriptionDiscount } from '../../../../../utils/mappers/serviceMapper/utils/payment.mapper';
import { getSubscriptionDiscountDuration } from '../../../../../utils/subscription/getSubscriptionDiscountDescription';
import { DiscountRuleName } from '../../Discount/Discount';
import { PaymentSummaryDataHook } from '../dataHooks';

export const SubscriptionDiscounts = ({
  discount,
  totalPayments,
  isCart,
  calculatedAtCheckout,
}: {
  discount: SubscriptionDiscount;
  totalPayments: number;
  isCart: boolean | undefined;
  calculatedAtCheckout?: boolean;
}) => {
  const { t } = useTranslation();
  const showCheckoutNotice = isCart || calculatedAtCheckout;
  return (
    <div data-hook={PaymentSummaryDataHook.Subscription_Discounts}>
      <DiscountRuleName
        name={discount.name}
        tooltipContent={
          showCheckoutNotice
            ? t(
                'app.payment.summary.subscription.discount.tooltip-with-checkout',
                {
                  duration: getSubscriptionDiscountDuration(
                    discount,
                    totalPayments,
                    t,
                  ),
                },
              )
            : getSubscriptionDiscountDuration(discount, totalPayments, t)
        }
        align="end"
        isCart={false}
      />
    </div>
  );
};
